<template>
  <div class="area-tree">
    <div class="top">
      <div class="buttons-group">
        <Button
          size="large"
          type="primary"
          @click="save"
          style="margin-right: 10px"
          >保存</Button
        >
        <Button size="large" @click="back">返回</Button>
      </div>
    </div>
    <div class="bottom">
      <div class="bottonm-head">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th style="width: 20%">省</th>
              <th style="width: 20%">市</th>
              <th style="width: 60%">区</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
      <div class="bottom-body">
        <!-- province -->
        <div class="td">
          <div
            v-for="(p, pIndex) in baseAreaAll"
            :class="['cell']"
            :key="p.code"
          >
            <div class="column">
              <div
                :class="[
                  'cb-wrap',
                  p.parentCheckStatus == 'part' ? 'cb-part-wrap' : '',
                  p.parentCheckStatus == 'all' ? 'cb-all-wrap' : '',
                ]"
              >
                <input
                  type="checkbox"
                  id="checkbox"
                  :checked="p.checked"
                  @click="checkProvinceAll(p, pIndex, $event)"
                />
              </div>
              <!-- <Checkbox
                :indeterminate="p.parentCheckStatus == 'part'"
                :value="Boolean(p.parentCheckStatus == 'all')"
              ></Checkbox> -->
              <span @click="selectProvince(p, pIndex)">{{ p.name }}</span>
            </div>
          </div>
        </div>
        <!-- city -->
        <div class="td">
          <div v-for="(p, pIndex) in baseAreaAll" :key="p.code">
            <div class="column" v-show="currentP == p.code">
              <div
                v-for="(c, cIndex) in p.children || []"
                :class="['cell']"
                :key="c.code"
              >
                <div
                  :class="[
                    'cb-wrap',
                    c.parentCheckStatus == 'part' ? 'cb-part-wrap' : '',
                    c.parentCheckStatus == 'all' ? 'cb-all-wrap' : '',
                  ]"
                >
                  <input
                    type="checkbox"
                    id="checkbox"
                    :checked="c.checked"
                    @click="checkCityAll(p, pIndex, c, cIndex, $event)"
                  />
                </div>
                <!-- <Checkbox
                  :indeterminate="c.parentCheckStatus == 'part'"
                  :value="Boolean(c.parentCheckStatus == 'all')"
                  @click="checkCityAll(p, pIndex, c, cIndex, $event)"
                ></Checkbox> -->
                <span @click="selectCity(c, cIndex)"
                  >{{ c.name }}{{ c.parentCheckStatus || "-" }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- area -->
        <div class="td">
          <div v-for="(p, pIndex) in baseAreaAll" :key="p.code">
            <div v-for="(c, cIndex) in p.children || []" :key="c.code">
              <div
                class="column"
                v-show="currentP == p.code && currentC == c.code"
              >
                <div v-for="(a, aIndex) in c.children || []" :key="a.code">
                  <div :class="['cb-wrap', a.checked ? 'cb-all-wrap' : '']">
                    <input
                      type="checkbox"
                      id="checkbox"
                      :checked="a.checked"
                      @click="
                        areaCheckChange(p, pIndex, c, cIndex, a, aIndex, $event)
                      "
                    />
                    <span>{{ a.name }}</span>
                  </div>

                  <!-- <Checkbox
                    class="cell"
                    :key="a.code"
                    :label="a.code"
                    :value="false"
                    @click="
                      areaCheckChange(p, pIndex, c, cIndex, a, aIndex, $event)
                    "
                    >{{ a.name }}</Checkbox
                  > -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      currentP: 0,
      currentC: 0,
      selectArea: {},
    };
  },
  computed: {
    ...mapGetters("base", {
      baseAreaAll: "getBaseAreaAll",
    }),
  },
  watch: {},
  created() {
    this.$Spin.show();
    this.$store
      .dispatch("base/getBaseAreaAll")
      .then((res) => {})
      .finally(this.$Spin.hide);
  },
  mounted() {},
  methods: {
    selectProvince(p, index) {
      console.log(p, index);
      //   this.$set(this, "city", p.children);
      this.$set(this, "currentP", p.code);
      //   this.$set(this, "currentC", 0);

      //   this.selectCity(p.children[this.currentC], this.currentC);
    },
    selectCity(c, index) {
      //   this.$set(this, "county", c.children);
      this.$set(this, "currentC", c.code);

      //   this.$set(this, "areaCheckGroup", []);
    },
    checkProvinceAll(p, pIndex, event) {
      (p.children || []).forEach((c, i) => {
        this.checkCityAll(p, pIndex, c, i, event);
      });
    },
    checkCityAll(p, pIndex, c, cIndex, event) {
      (c.children || []).forEach((a, i) => {
        this.areaCheckChange(p, pIndex, c, cIndex, a, i, event);
      });
    },
    areaCheckChange(p, pIndex, c, cIndex, a, aIndex, event) {
      const flag = event.target.checked;
      this.$set(a, "checked", flag);
      const ckey = "" + c.code;
      console.log(this.selectArea[ckey], c, aIndex, "cccc");
      // 选中
      if (flag) {
        // 记录当前area code
        if (!this.selectArea[ckey]) {
          this.$set(this.selectArea, ckey, new Array(c.children.length));
        }

        this.selectArea[ckey].splice(aIndex, 1, a);
      }
      // 取消选中
      else {
        // 清空当前area code
        this.selectArea[ckey].splice(aIndex, 1, false);
      }

      // 判断当前区域选择数量
      // step1: city
      const cStatus = this.judgeAreaNumber(
        this.selectArea[ckey].filter((i) => !!i).length,
        c.children.length
      );
      console.log(cStatus, this.selectArea[ckey], "cStatus");
      this.$set(p.children[cIndex], "parentCheckStatus", cStatus);
      // step2: province
      // 获取当前已选择城市数量
      let count = 0;
      p.children.forEach((c) => {
        if (c.parentCheckStatus == "all" || c.parentCheckStatus == "part") {
          count++;
        }
      });
      const pStatus = this.judgeAreaNumber(count, p.children.length);
      this.$set(this.baseAreaAll[pIndex], "parentCheckStatus", pStatus);

      console.log("已经选中: ", this.selectArea);
    },
    judgeAreaNumber(checkLen, allLen) {
      // 全部选中
      if (checkLen >= allLen) {
        return "all";
      }
      // 部分选中
      else if (checkLen > 0) {
        return "part";
      }
      // 没有选中
      else {
        return "none";
      }
    },
    save() {},
    back() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
/* 滚动条宽度 */
::-webkit-scrollbar {
  width: 0;
  background-color: transparent;
}

/* 滚动条颜色 */
::-webkit-scrollbar-thumb {
  background-color: #27314d;
}

.area-tree {
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.top {
  flex: 0 0 auto;
}

.bottom {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  height: 80vh;
  overflow: hidden;
}

.bottonm-head {
  flex: 0 0 auto;
}

.bottom-body {
  flex: 1 1 auto;
  overflow: auto;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e7e7e7;
}

.td {
  flex: 1 1 auto;
}

.cb-wrap {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: relative;
  border-color: #2d8cf0;
  background-color: #ffffff;
  border: 1px solid #dcdee2;
  border-radius: 2px;
  overflow: hidden;
  transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}

.cb-wrap input {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}

.cb-part-wrap {
  background-color: #2d8cf0;
}

.cb-all-wrap {
  background-color: #2d8cf0;
}

.cb-part-wrap::after {
  content: "";
  width: 10px;
  height: 1px;
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 6px;
  display: table;
  position: absolute;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transition: all 0.2s ease-in-out;
}
.cb-all-wrap::after {
  content: "";
  display: table;
  width: 4px;
  height: 8px;
  position: absolute;
  top: 2px;
  left: 5px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1);
  transition: all 0.2s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/views/test.vue